import { CreditCardPaymentResult } from '../../revenue/shared/credit-card/credit-card-payment-result.model';
import { CreditCardService } from '../../revenue/shared/credit-card/credit-card.service';
import { CreditCardGatewayService } from '../../revenue/shared/credit-card-gateway/credit-card-gateway.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { ProfileRead } from '../../profiles/shared/profile-read.model';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/profiles/shared/profile.service';
import { InvoiceWithPaymentDto, initializedInvoiceWithPaymentDto } from 'src/app/invoices/dto/invoice-with-payment.dto';
import { NewMemberService } from '../shared/new-member.service';
import { CreditCardGateway } from 'src/app/revenue/shared/credit-card-gateway/credit-card-gateway.model';
import { NotificationService } from 'src/app/shared';
import { getSafe } from 'src/app/shared/util/get-safe';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'wl-new-member-invoice',
  templateUrl: './new-member-invoice.component.html',
  styleUrls: ['./new-member-invoice.component.less'],
  providers: [CreditCardService],
    standalone: false
})
export class NewMemberInvoiceComponent implements OnInit {
  public invoiceWithPayment: InvoiceWithPaymentDto;
  public profileId: number;
  public profile: ProfileRead;
  public isSaving: boolean;
  constructor(
    private _profileService: ProfileService,
    private _route: ActivatedRoute,
    private _newMemberService: NewMemberService,
    private _navigationService: NavigationService,
    private _creditCardGatewayService: CreditCardGatewayService,
    private _creditCardService: CreditCardService,
    private _notificationService: NotificationService,
    private _title: Title
  ) {
    this.profile = new ProfileRead();
    this.invoiceWithPayment = initializedInvoiceWithPaymentDto();
  }

  ngOnInit() {
    this._route.params.subscribe((id) => {
      this.profileId = parseInt(id['id'], 10);
      this._profileService.getProfile(this.profileId).then((data) => {
        this.profile = data;
        this._title.setTitle(this._title.getTitle() + ' ' + this.profile.ReportName);
      });
    });
    this._creditCardGatewayService.getCreditCardGateways().then((data: Array<CreditCardGateway>) => {
      if (data.length > 0) {
        this.invoiceWithPayment.CreditCardPayment.CCGatewayID = data[0].CCGatewayID;
      }
    });
  }

  saveClick() {
    this.isSaving = true;
    this.copyToPayableInvoiceLineItems();
    this.processCreditPayment().then((data: CreditCardPaymentResult) => {
      if (data && !data.Succeeded) {
        this._notificationService.error(data.RawTransactionResult);
        this.isSaving = false;
        return;
      } else if (data) {
        this.invoiceWithPayment.Invoice.PaymentHeader.CC_CreditCardNum = data.CcId;
      }
      this._newMemberService.createInvoice(this.profileId, this.invoiceWithPayment).then(
        () => {
          this.isSaving = false;
          this._navigationService.navigateToProfileView(this.profileId);
        },
        () => {
          this.isSaving = false;
        }
      );
    });
  }

  private processCreditPayment() {
    if (getSafe(() => this.invoiceWithPayment.Invoice.PaymentHeader._paymentType.CreditCardType)) {
      this.invoiceWithPayment.CreditCardPayment.Amount = this.invoiceWithPayment.Invoice.PaymentHeader.Amount;
      this.invoiceWithPayment.CreditCardPayment.ProfileId = this.invoiceWithPayment.Invoice.PaymentHeader.ProfileID;
      this._creditCardService.fillPaymentHeaderFieldsWithCcInfo(
        this.invoiceWithPayment.CreditCardPayment,
        this.invoiceWithPayment.Invoice.PaymentHeader
      );
      return this._creditCardService.processCreditCardPayment(this.invoiceWithPayment.CreditCardPayment);
    }
    return Promise.resolve(null);
  }

  private copyToPayableInvoiceLineItems() {
    // Copy the InvoiceLineItems to the PayableInvoiceLineItems before saving
    this.invoiceWithPayment.Invoice.PayableInvoiceLineItems = this.invoiceWithPayment.Invoice.InvoiceLineItems.map((x) => ({ ...x }));
  }
}
